import React, { useState, useEffect, Suspense } from "react";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { apiService } from "../../../api/apiAdapter";
import { useNavigate } from "react-router-dom";

const Footer = React.lazy(() => import("../../../components/footer"));

const XeroAuth = () => {
  const { accounts } = useMsal();
  const navigate = useNavigate();
  const [accountInfo, setAccountInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const email =
    accounts[0]?.username ||
    accounts[0]?.idTokenClaims?.email ||
    accounts[0]?.idTokenClaims?.["signInNames.emailAddress"];
  const isTgUser = email?.includes("@tg.org.au");

  useEffect(() => {
    if (!isTgUser) navigate("/");
  }, [isTgUser, navigate]);

  const connectXero = async () => {
    const clientId = import.meta.env.REACT_APP_XERO_CLIENT_ID;
    const redirectUrl = import.meta.env.REACT_APP_XERO_REDIRECT_URL;
    const xeroAuthUrl = `https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUrl,
    )}&scope=openid profile email accounting.transactions accounting.settings accounting.contacts offline_access`;

    window.location.href = xeroAuthUrl;
  };

  const getXeroAccounts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.getXeroAccounts();
      //console.log(" xero auth Response:", response);

      setAccountInfo(response);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Suspense fallback={<div className="loader"></div>}>
      <MsalAuthenticationTemplate>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h3>Xero Integration Setup</h3>

              {/* Connect to Xero Section */}
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h3 className="panel-title">Step 1: Connect to Xero</h3>
                </div>
                <div className="panel-body">
                  <p>Connect your Xero account to get started.</p>
                  <button className="btn btn-primary" onClick={connectXero}>
                    Connect to Xero
                  </button>
                </div>
              </div>

              {/* Get Account Information Section */}
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h3 className="panel-title">Step 2: Verify Account Setup</h3>
                </div>
                <div className="panel-body">
                  <p>Retrieve and verify your Xero account information.</p>
                  <button className="btn btn-primary" onClick={getXeroAccounts} disabled={loading}>
                    {loading ? "Loading..." : "Get Account Information"}
                  </button>

                  {error && (
                    <div className="alert alert-danger" style={{ marginTop: "15px" }}>
                      <strong>Error:</strong> {error}
                    </div>
                  )}

                  {accountInfo && (
                    <div style={{ marginTop: "20px" }}>
                      <h4>Account Information:</h4>
                      <div className="alert alert-info">
                        <strong>Tenant ID:</strong> {accountInfo.tenantId}
                      </div>

                      {accountInfo.message && (
                        <div className="alert alert-success">{accountInfo.message}</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </MsalAuthenticationTemplate>
      <Footer />
    </Suspense>
  );
};

export default XeroAuth;
